import React from "react";
import {observer} from "mobx-react";
import {EmbedsMessage} from "./EmbedsMessage";
import {Message} from "../../lib/stores/MessageStore";
import ContentMessage from "./ContentMessage";


function ChatMessage(
        {
            message
        }: {
            message: Message
        }) {
    return message.embeds && message.embeds?.length > 0 ? <EmbedsMessage message={message}/> :
            <ContentMessage message={message}/>
}

export default observer(ChatMessage);
